import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Logger } from '@x/common/log';
import { AuthLogout } from '@x/ecommerce-shop/app/core/auth/state/auth.actions';
import { ShopStorage } from '@x/ecommerce-shop/app/core/shop-storage/shop-storage.service';
import { ShopUserService } from '@x/ecommerce/shop-client';
import { firstValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean> => {
  const router = inject(Router);
  const store = inject(Store);
  const shopUserService = inject(ShopUserService);
  const shopStorage = inject(ShopStorage);
  const logger = inject(Logger);

  try {
    const userToken = shopStorage.userToken?.token;
    if (!userToken) throw new Error();

    // update local storage
    shopStorage.userToken = await firstValueFrom(shopUserService.refreshUserToken());

    return true;
  } catch (e) {
    logger.info('%cCant authenticate user, routing to login', 'color: DodgerBlue');

    // clear auth state
    await firstValueFrom(store.dispatch(new AuthLogout()));

    // redirect to login
    await router.navigate(['/login'], {
      queryParams: { ...route.queryParams, blockedRoute: state.url.split('?')[0] },
    });

    return false;
  }
};
